import { coreService } from "../../../../services/coreService";
import { buildQuery } from "../../../../lib/network";

export type IUpdateOnSiteContactInfo = {
  onSiteContactName: string | undefined;
  onSiteContactPhone: string;
  onSiteContactApplicantInstructions?: string;
};
export default function putInspectionsPublicOnSiteContactInfo(headers: any, id: number) {
  return (data: IUpdateOnSiteContactInfo) => {
    return buildQuery(
      coreService.inspectionsPublicOnSiteContactInfoUpdate(
        id,
        {
          onSiteContactName: data.onSiteContactName,
          onSiteContactPhone: data.onSiteContactPhone,
          onSiteContactApplicantInstructions: data.onSiteContactApplicantInstructions,
        },
        { headers },
      ),
      (response) => {
        return response.data;
      },
    );
  };
}
